var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.customText.format === "Un-Styled"
    ? _c("span", { domProps: { innerHTML: _vm._s(_vm.customText.content) } })
    : _c("p", {
        class: _vm.textClasses,
        domProps: { innerHTML: _vm._s(_vm.customText.content) },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }